import React, { useState } from 'react';

interface ITrainingFeedbackDialogProps {
    onSubmitFeedbackComment: (comment: string) => void;
    onEndAlert: () => void;
}

export const TrainingFeedbackDialog = ({
    onSubmitFeedbackComment,
    onEndAlert,
}: ITrainingFeedbackDialogProps) => {
    const [feedbackComment, setFeedbackComment] = useState('');

    return (
        <div style={{ width: '100%' }}>
            <p>
                If you feel there is a problem with this module or if there's any additional
                information we could add to make it more useful, please let us know.
            </p>
            <p>
                Whilst we can't guarantee to reply to every piece of feedback that we receive, all
                feedback will be reviewed by our Product Team.
            </p>
            <form
                onSubmit={e => {
                    e.preventDefault();
                    onSubmitFeedbackComment(feedbackComment);
                    onEndAlert();
                }}
            >
                <textarea
                    required
                    placeholder="Your feedback"
                    rows={5}
                    onChange={e => {
                        setFeedbackComment(e.target.value);
                    }}
                ></textarea>
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'flex-end',
                    }}
                >
                    <button
                        className="training-mode-feedback-dialog-button cancel"
                        type="button"
                        onClick={() => onEndAlert()}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={feedbackComment === ''}
                        className="training-mode-feedback-dialog-button"
                        type="submit"
                    >
                        Submit feedback
                    </button>
                </div>
            </form>
        </div>
    );
};
